import { memo } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

export interface FloatingDropAreaProps {
  isOver: boolean;
  orientation: "horizontal" | "vertical";
}

export const FloatingDropArea = memo(
  ({ isOver, orientation }: FloatingDropAreaProps) => {
    const isVertical = orientation === "vertical";

    return (
      <div
        className={classNames(
          "absolute transition-all",
          {
            // Horizontal layout (default) - centered horizontally
            "top-1/2 w-full -translate-y-1/2": !isVertical,
            "before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:content-['']":
              !isVertical,
            "before:h-0 before:w-0 before:border-y-[6px] before:border-y-transparent":
              !isVertical,
            "after:absolute after:right-0 after:top-1/2 after:-translate-y-1/2 after:content-['']":
              !isVertical,
            "after:h-0 after:w-0 after:border-y-[6px] after:border-y-transparent":
              !isVertical,
            // Vertical layout - centered arrows on the line
            "left-0 h-full": isVertical,
            "before:absolute before:left-1/2 before:top-0 before:-translate-x-1/2 before:content-['']":
              isVertical,
            "before:h-0 before:w-0 before:border-x-[6px] before:border-x-transparent":
              isVertical,
            "after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:content-['']":
              isVertical,
            "after:h-0 after:w-0 after:border-x-[6px] after:border-x-transparent":
              isVertical,
          },
          {
            // Horizontal active state
            "h-[2px] bg-blue-500 before:border-l-[8px] before:border-l-blue-500 after:border-r-[8px] after:border-r-blue-500":
              isOver && !isVertical,
            // Vertical active state - centered arrows on the line
            "w-[2px] bg-blue-500 before:border-t-[8px] before:border-t-blue-500 after:border-b-[8px] after:border-b-blue-500":
              isOver && isVertical,
          },
        )}
        data-testid="builder-ui-floating-drop-area"
      />
    );
  },
);

FloatingDropArea.displayName = "FloatingDropArea";
